import PropTypes from 'prop-types';

export default PropTypes.oneOf(['Chronos', 'email', 'ios', 'android', 'web', 'email', '']);
